import { graphql, useStaticQuery } from 'gatsby'

export const useSwaggerMetadata = () => {
  const { allExternalJson } = useStaticQuery(
    graphql`
      query allExternalJson {
        allExternalJson {
          nodes {
            info {
              description
              title
              version
            }
            basePath
            consumes
            host
            id
            isDeprecated
            latestVersion
            latestVersionPath
            produces
            schemes
            swagger
            version
            versions {
              selected
              version
            }
            externalDocs {
              url
            }
            definitions {
              description
              format
              href
              minItems
              name
              parentName
              readOnly
              title
              type
              properties {
                defaultValue
                description
                exclusiveMinimum
                enum
                format
                href
                link
                linkArray
                maxItems
                maxLength
                minItems
                uniqueItems
                type
                title
                required
                readOnly
                pattern
                parentName
                name
                minimum
                minLength
                maximum
                _ref
              }
            }
          }
        }
      }
    `,
  )
  return allExternalJson
}
